import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseAlertModule } from '@fuse/components/alert';
import { KeycloakUser } from 'app/app.type';
import { KeycloakAdminService } from '../service/keycloak-admin.service';
import { GroupSelectorComponent } from './group-selector/group-selector.component';

@Component({
	selector: 'register-user-modal',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatDialogModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatIconModule,
		FuseAlertModule,
		MatTooltipModule,
		GroupSelectorComponent
	],
	templateUrl: './register-user-modal.component.html'
})
export class RegisterUserModalComponent {
	private readonly data = inject<any>(MAT_DIALOG_DATA);
	private readonly fb = inject(FormBuilder);
	private readonly dialogRef = inject(MatDialogRef<RegisterUserModalComponent>);

	keycloakAdminService = inject(KeycloakAdminService);

	registerForm: FormGroup;
	registering = false;

	userPassword = this.keycloakAdminService.generateTemporaryPassword();

	constructor() {
		this.registerForm = this.fb.group({
			firstName: [undefined, [Validators.required]],
			lastName: [undefined, [Validators.required]],
			email: [undefined, [Validators.required, Validators.email]],
			username: undefined,
			password: [this.userPassword],
			emailVerified: true,
			enabled: true,
			groups: [undefined, [Validators.required]]
		});
	}

	cancel(): void {
		console.warn(this.registerForm.value)
		this.dialogRef.close();
	}

	register(): void {
		if (this.registerForm.valid) {
			this.registering = true;

			const selectedGroups = this.registerForm.value.groups;
			const groupsArray = Array.isArray(selectedGroups) ? selectedGroups : [selectedGroups];

			const newUser: Partial<KeycloakUser> = {
				firstName: this.registerForm.value.firstName,
				lastName: this.registerForm.value.lastName,
				email: this.registerForm.value.email,
				username: this.registerForm.value.email,
				enabled: true,
				emailVerified: true,
				groups: groupsArray.filter(group => group) // Remove any undefined values
			};

			// Call the service to create the user
			this.keycloakAdminService.createUser(newUser, this.registerForm.value.password).subscribe({
				next: (res) => {
					console.log('User created successfully:', res);
					this.registering = false;
					this.dialogRef.close(newUser);
				},
				error: (error) => {
					console.error('Error creating user:', error);
					this.registering = false;
				}
			});
		}
	}

	copyPasswordToClipboard(): void {
		navigator.clipboard.writeText(this.userPassword).then(() => {
			console.log('Password copied to clipboard');
		}).catch(err => {
			console.error('Could not copy password: ', err);
		});
	}
}
